import { Link } from "react-router-dom";
import { accentBadge } from "../lib/accentTokens";

export default function StatCard({
    label,
    value,
    hint,
    icon: Icon,
    accent = "action",
    to,
    testId,
}) {
    const a = accentBadge[accent] || accentBadge.action;

    const inner = (
        <div
            className="bg-white rounded-3xl border border-mist card-soft p-6 sm:p-7 transition-all duration-300 hover:-translate-y-1"
            data-testid={testId}
        >
            <div className="flex items-start justify-between mb-4">
                <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">
                    {label}
                </span>
                {Icon && (
                    <div
                        className={`w-10 h-10 rounded-xl ${a.bg} flex items-center justify-center`}
                    >
                        <Icon className={a.text} size={20} strokeWidth={2.5} />
                    </div>
                )}
            </div>
            <div className="font-display font-bold text-5xl sm:text-6xl leading-none text-slate-900">
                {value}
            </div>
            {hint && (
                <div className="mt-3 text-sm text-slate-500 font-medium">{hint}</div>
            )}
        </div>
    );

    if (to) return <Link to={to}>{inner}</Link>;
    return inner;
}
